/**
 * Which of the three sites this bundle is currently serving.
 *
 * The dashboard, turksletloose.com and join.turksletloose.com ship as one build
 * behind one nginx; only the hostname separates them. The `/join` and `/home`
 * path mounts are the escape hatch for looking at the public sites without a
 * second DNS name — they run the same routes under a router basename.
 */
export const JOIN_BASENAME = '/join'
export const HOME_BASENAME = '/home'

const path = window.location.pathname
const onMount = (base: string) => path === base || path.startsWith(`${base}/`)

export const isJoinPathMount = onMount(JOIN_BASENAME)
export const isHomePathMount = onMount(HOME_BASENAME)

const subdomain = window.location.hostname.split('.')[0]

export const isJoinSite = subdomain === 'join' || isJoinPathMount

/**
 * The public community site: the bare apex and its `www` alias. Everything else
 * (dashboard.turksletloose.com, an IP, localhost) stays the dashboard, so local
 * development is unaffected — use /home to reach this site there.
 */
export const isHomeSite =
  !isJoinSite &&
  (subdomain === 'turksletloose' || subdomain === 'www' || isHomePathMount)

/**
 * Where the public site's "apply" buttons point. On the real apex that is the
 * separate recruitment hostname; under the /home mount there is no such
 * hostname, so it stays inside this bundle at /join.
 */
export const JOIN_SITE_URL = isHomePathMount
  ? JOIN_BASENAME
  : 'https://join.turksletloose.com'

/**
 * Mirror of JOIN_SITE_URL: where the recruitment site points back to the
 * community site. Under the /join path mount there is no apex hostname, so it
 * stays inside this bundle at /home.
 */
export const HOME_SITE_URL = isJoinPathMount
  ? HOME_BASENAME
  : 'https://turksletloose.com'

/** Same idea for the members-only dashboard link in the public site's footer. */
export const DASHBOARD_SITE_URL = isHomePathMount
  ? '/'
  : 'https://dashboard.turksletloose.com'
